module.exports = __webpack_public_path__ + "img/mobile-banner2-tw.08c5ccc7.jpg";